module.exports = __webpack_public_path__ + "img/org-review-good.1f1cff21.svg";